// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2278":"ed54d9ee","3641":"e9c6c033","3656":"a206df31","7639":"6a0aae1f","8893":"ed54d9ee"}[chunkId] + ".chunk.css";
};